import { hasContentInHTMLTags } from 'src/app/common/function';
import { ArticleBlock } from '../../../../models/article';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, Renderer2, ElementRef, OnChanges } from '@angular/core';
import { Editor, Toolbar, nodes as basicNodes, marks } from 'ngx-editor';
import { isNodeActive } from 'ngx-editor/helpers';
import { setBlockType } from 'prosemirror-commands';
import { NodeSpec, Schema } from 'prosemirror-model';
import { EditorState, Plugin, PluginKey, Transaction } from 'prosemirror-state';
import { EditorView } from 'prosemirror-view';


@Component({
  selector: 'app-article-subline',
  templateUrl: './article-subline.component.html',
  styleUrls: ['./article-subline.component.scss']
})
export class ArticleSublineComponent implements OnInit, OnDestroy, OnChanges {

  @Output() blockElementChange = new EventEmitter<ArticleBlock>();

  @Input() blockElement: ArticleBlock;

  subLineStyle: NodeSpec = {
    content: 'text*',
    marks: '',
    group: 'block',
    code: false,
    defining: true,
    isolating: true,
    toDOM() { return ["p", { class: "subline-text" }, 0] },
    parseDOM: [{ tag: "p.subline-text", priority: 60 }]
  };

  nodes = Object.assign({}, basicNodes, {
    subLine: this.subLineStyle,
    paragraph: basicNodes.paragraph
  });

  schema = new Schema({
    nodes: this.nodes,
    marks,
    topNode: 'subLine'
  });

  editor: Editor;
  toolbar: Toolbar = [];

  constructor(private renderer: Renderer2, private el: ElementRef) { }

  ngOnInit(): void {
    this.editor = new Editor({
      schema: this.schema,
    });
  }

  ngOnChanges(): void {
    setTimeout(() => {
      if (this.blockElement?.isActiveForEdit) {
        const editorElement = this.el.nativeElement.querySelector('.ProseMirror.NgxEditor__Content');
        this.renderer.setAttribute(editorElement, 'autofocus', 'true');
        editorElement.focus();

        const { state, dispatch } = this.editor.view;
        const currentType = state.selection.$from.parent.type;
        if (currentType !== this.schema.nodes['subLine']) {
          setBlockType(this.schema.nodes['subLine'])(state, dispatch);
        }
      }
    }, 700);
  }

  onChange(e: string) {
    this.blockElement.data = e;
    this.blockElementChange.emit(this.blockElement);
  }

  ngOnDestroy(): void {
    this.editor.destroy();
  }
}
